/**
 * Mode toggle for the post editor: linear document view vs free 2D
 * canvas view. Visually matches the existing Read/Edit toggle in the
 * TopBar — same `view-mode-toggle` / `view-mode-btn` class set, same
 * dark-filled active state, same uppercase 11px lettering.
 *
 * Phase 5a runtime scope: doc | canvas only. chat / review modes
 * land in Phase 5b/c when the dedicated layouters are wired.
 */
export type EditorMode = 'doc' | 'canvas'

interface Props {
  mode: EditorMode
  onChange: (mode: EditorMode) => void
  disabled?: boolean
}

export function ModeToggle({ mode, onChange, disabled = false }: Props) {
  return (
    <div className="view-mode-toggle" role="tablist" aria-label="View mode">
      <button
        type="button"
        role="tab"
        aria-selected={mode === 'doc'}
        disabled={disabled}
        onClick={() => onChange('doc')}
        className={`view-mode-btn ${mode === 'doc' ? 'active' : ''}`}
      >
        Doc
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={mode === 'canvas'}
        disabled={disabled}
        onClick={() => onChange('canvas')}
        className={`view-mode-btn ${mode === 'canvas' ? 'active' : ''}`}
      >
        Canvas
      </button>
    </div>
  )
}
